
      import Calculator from './calculator.vue'
      import type { App, Plugin } from 'vue'

      export const CalculatorPlugin: Plugin = {
        install(app: App) {
          app.component('Calculator', Calculator)
        },
      }
      export { Calculator }
      